// Servicio API para expediente del cliente autenticado (portal /clientes)
import { api } from './api';
import type { ClienteFichaResponse } from '@/types/clienteFicha';
import type { ExpedienteArchivoRead } from '@/types/expediente';
import { normalizeFichaResponse } from './clienteFichaService';

export const clienteExpedienteService = {
  /** Ficha unificada del cliente: contratos, expediente, timeline */
  async getFicha(): Promise<ClienteFichaResponse> {
    const { data } = await api.get('/clientes/ficha');
    return normalizeFichaResponse(data as Record<string, unknown>, 'portal');
  },

  /** Documentos adjuntos del expediente */
  async getDocuments(expedienteId: string): Promise<ExpedienteArchivoRead[]> {
    const { data } = await api.get<ExpedienteArchivoRead[]>(
      `/expedientes/${expedienteId}/documents`
    );
    return data;
  },

  /** Subir documento al expediente */
  async uploadDocument(
    expedienteId: string,
    file: File,
    tipoDocumento?: string
  ): Promise<ExpedienteArchivoRead> {
    const formData = new FormData();
    formData.append('file', file);
    if (tipoDocumento) {
      formData.append('tipo_documento', tipoDocumento);
    }
    const { data } = await api.post<ExpedienteArchivoRead>(
      `/expedientes/${expedienteId}/documents`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data;
  },

  /** Eliminar documento del expediente */
  async deleteDocument(expedienteId: string, fileId: string): Promise<void> {
    await api.delete(`/expedientes/${expedienteId}/documents/${fileId}`);
  },
};
